import { DiscussionContext } from "@cnx/common";
import { Box, Text } from "@mantine/core";
import { IconMail, IconRoute, IconTruck, IconUser } from "@tabler/icons-react";
import InfoItem from "components/InfoItem";
import IconTruckTrailer from "icons/shipment/truck-body.svg";
import ChatContextAddressItem from "./ChatContextAddressItem";
import ChatContextLocationItem from "./ChatContextLocationItem";
import ChatContextTemperatureItem from "./ChatContextTemperatureItem";

interface ChatContextDropdownProps {
  discussionContext: DiscussionContext;
}

const ChatContextDropdownContent: React.FC<ChatContextDropdownProps> = ({
  discussionContext: {
    trailer,
    truck,
    driver,
    locationName,
    locationZipCode,
    locationCityName,
    countryCode,
    locationAddress,
    tripId,
    receiver,
    receiverName,
    senderName,
    sender,
    mailId,
    temperatureMax,
    temperatureMin,
  },
}) => {
  return (
    <>
      {(trailer || truck) && (
        <Box className="flex flex-row items-start gap-[60px]">
          <InfoItem
            gap={8}
            visible={!!trailer}
            icon={<IconTruckTrailer className="w-6 h-6" />}
            label={<Text fz={14}>{trailer}</Text>}
          />
          <InfoItem
            gap={8}
            visible={!!truck}
            icon={<IconTruck className="w-6 h-6" />}
            label={<Text fz={14}>{truck}</Text>}
          />
        </Box>
      )}
      <InfoItem
        gap={8}
        align="flex-start"
        visible={!!driver}
        icon={<IconUser className="w-6 h-6" />}
        label={
          <Text fz={14} className="wrap-break-word">
            {driver?.split(";").join(", ")}
          </Text>
        }
      />
      <ChatContextLocationItem
        locationName={locationName}
        locationAddress={locationAddress}
        locationZipCode={locationZipCode}
        locationCityName={locationCityName}
        countryCode={countryCode}
      />
      <InfoItem
        gap={8}
        visible={!!tripId}
        icon={<IconRoute className="w-6 h-6" />}
        label={<Text fz={14}>{tripId}</Text>}
      />
      <ChatContextAddressItem
        type="receiver"
        value={receiver}
        name={receiverName}
      />
      <ChatContextAddressItem type="sender" value={sender} name={senderName} />
      <InfoItem
        gap={8}
        visible={!!mailId}
        icon={<IconMail className="w-6 h-6" />}
        label={<Text fz={14}>{mailId}</Text>}
      />
      <ChatContextTemperatureItem
        temperatureMin={temperatureMin}
        temperatureMax={temperatureMax}
      />
    </>
  );
};

export default ChatContextDropdownContent;
